import { Box } from 'braid-design-system';

import { LOADER_SIZE } from 'src/app/shared/constants/paymentInProgress';

import * as styles from './Loader.css';

export const Loader = () => (
  <Box style={{ height: LOADER_SIZE, width: LOADER_SIZE }}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={styles.quarterCircleLightBlue1}
        cx="100"
        cy="100"
        r="50"
        strokeWidth="100"
        pathLength="100"
      />
      <circle
        className={styles.halfDonutPink}
        cx="100"
        cy="100"
        r="68.75"
        strokeWidth="62.5"
        pathLength="100"
      />
      <circle
        className={styles.halfDonutDarkBlue}
        cx="100"
        cy="100"
        r="68.75"
        strokeWidth="62.5"
        pathLength="100"
      />
      <circle
        className={styles.halfCircleDarkBlue}
        cx="100"
        cy="100"
        r="50"
        strokeWidth="100"
        pathLength="100"
      />
      <circle
        className={styles.halfCirclePink}
        cx="100"
        cy="100"
        r={styles.halfCirclePinkRadius}
        strokeWidth="100"
      />
      <circle
        className={styles.quarterCircleLightBlue2}
        cx="100"
        cy="100"
        r="50"
        strokeWidth="100"
        pathLength="100"
      />
    </svg>
  </Box>
);
